export const DIGITAL_TRAPS_CONTAINER = 'digital-traps-container';
export const DIGITAL_TRAPS_LIST = 'digital-traps-list';
export const DIGITAL_TRAPS_LOADING = 'digital-traps-loading';
export const DIGITAL_TRAPS_FILTERS_CONTAINER = 'digital-traps-filters-container';

// Tabs
export const DAILY_COUNTS_TAB = 'daily-counts-tab';
export const FLIGHT_PREDICTIONS_TAB = 'flight-predictions-tab';
export const OBSERVED_PREDICTIONS_TOGGLE = 'observed-predictions-toggle';

// Daily Counts observed cards
export const DAILY_COUNTS_OBSERVED_CARD_LIST = 'daily-counts-observed-card-list';
export const DAILY_COUNTS_NETWORK_GROUP_CARD = 'daily-counts-network-group-card';
export const DAILY_COUNTS_TRAP_SUMMARY_CARD = 'daily-counts-trap-summary-card';

// Daily Counts flight-prediction cards
export const DAILY_COUNTS_PREDICTIONS_CARD_LIST = 'daily-counts-predictions-card-list';
export const DAILY_COUNTS_PREDICTIONS_TRAP_CARD = 'daily-counts-predictions-trap-card';
export const FLIGHT_STAGE_TIMELINE = 'flight-stage-timeline';

export const FLIGHT_CURVE_TAB = 'flight-curve-tab';
export const FLIGHT_CURVE_GRAPH = 'flight-curve-graph';
export const FLIGHT_CURVE_SIDEBAR = 'flight-curve-sidebar';

export const FLIGHT_CURVE_GRAPH_HEADER = 'flight-curve-graph-header';
export const FLIGHT_CURVE_GRAPH_HEADER_TITLE = 'flight-curve-graph-header-title';
export const FLIGHT_CURVE_GRAPH_HEADER_DAYS_RANGE = 'flight-curve-graph-header-days-range';
export const FLIGHT_CURVE_GRAPH_FLIGHT_STAGE_LOADING = 'flight-curve-graph-flight-stage-loading';
export const FLIGHT_CURVE_GRAPH_FLIGHT_STAGE_EMPTY = 'flight-curve-graph-flight-stage-empty';

export const NETWORK_MANAGEMENT_TAB = 'network-management-tab';

export const DIGITAL_TRAP_DETAILS = 'digital-trap-details';
export const DIGITAL_TRAP_DETAILS_HEADER = 'digital-trap-details-header';
export const DIGITAL_TRAP_DETAILS_PEST_PRESSURE = 'digital-trap-details-pest-pressure';
export const DIGITAL_TRAP_DETAILS_TRAP_HEALTH = 'digital-trap-details-trap-health';
export const DIGITAL_TRAP_DETAILS_FLIGHT_PREDICTIONS = 'digital-trap-details-flight-predictions';

export const DIGITAL_TRAP_DAILY_INSECT_COUNTS_STRIP = 'digital-trap-daily-insect-counts-strip';
export const DIGITAL_TRAP_DAILY_INSECT_COUNT_CHIP = 'digital-trap-daily-insect-count-chip';

export const DIGITAL_TRAP_EMPTY_STATE = 'digital-trap-empty-state';

export const DIGITAL_TRAP_TAB_LOADING = 'digital-trap-tab-loading';

export const DIGITAL_TRAP_PIN_CONTAINER = 'digital-trap-pin-container';
export const DIGITAL_TRAP_PIN_ICON = 'digital-trap-pin-icon';
export const DIGITAL_TRAP_ANALYSIS_PER_FIELD_ICON = 'digital-trap-analysis-per-field-icon';

export const DIGITAL_TRAPS_NETWORK_SELECT = 'digital-traps-network-select';

export const NETWORK_CARD_LIST_HEADER_EDIT_BUTTON = 'network-card-list-header-edit-button';
export const NETWORK_CARD_LIST_SELECT_ALL = 'network-card-list-select-all';
